import React, { Fragment } from "react";
import { Field, useForm, useFormState } from "react-final-form";
import { OnChange } from "react-final-form-listeners";

// Web Final Form Components
import { FormGroup, Label, Col, Row, ListGroupItem, ListGroup } from "reactstrap";
import { CheckboxField, InputField, ToggleField, required } from "modules/4_final_form/web";

// Mobile Final Form Components
import { InputField as MobileInputField } from "modules/4_final_form/mobile";
import TrueRequired from "modules/4_final_form/web/validators/TrueRequired";

export const CheckboxFieldAttributes = ({ fieldName, namesUsed }) => {
  const form = useForm();

  return (
    <Fragment>
      <FormGroup row>
        <Label md={3}>Label</Label>
        <Col md={8}>
          <Field name={`${fieldName}.label`} component={InputField} validate={required} />
          <OnChange name={`${fieldName}.label`}>
            {(value, previous) => {
              if (value) {
                let name = _.snakeCase(value);
                // Check first character is a number
                if (name.match(/^\d/)) {
                  name = `_${name}`;
                }
                form.change(`${fieldName}.name`, name);
              }
            }}
          </OnChange>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>Name</Label>
        <Col md={8}>
          <Field
            name={`${fieldName}.name`}
            component={InputField}
            validate={(value, values) => {
              if (!value) {
                return "is required";
              }
              if (namesUsed.includes(value)) {
                return "must be unique";
              }
            }}
            convertToLowerCase
            lettersOnly
          />
        </Col>
      </FormGroup>

      <FormGroup row>
        <Label md={3}>Required Field</Label>
        <Col md={8}>
          <Field name={`${fieldName}.required`} component={ToggleField} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>On Dashboard</Label>
        <Col md={8}>
          <Field name={`${fieldName}.on_dashboard`} component={ToggleField} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>On Report</Label>
        <Col md={8}>
          <Field name={`${fieldName}.on_report`} component={ToggleField} />
        </Col>
      </FormGroup>
    </Fragment>
  );
};

export const CheckboxFieldForm = (props) => {
  const { label, placeholder, required: isRequired, preview, name, prefixName, disabled } = props;

  const formState = useFormState();
  const isComplete = _.get(formState.values, name);

  return (
    <ListGroup>
      <ListGroupItem>
        <div className="p-2">
          <Field
            name={`${prefixName}.${name}`}
            disabled={preview || disabled}
            component={CheckboxField}
            placeholder={placeholder}
            style={{ width: "20px", height: "20px" }}
            validate={isRequired && !preview ? TrueRequired : null}
            label={label}
            format={(value) => value === true || value == "1"}
          />
        </div>
      </ListGroupItem>
    </ListGroup>
  );
};
CheckboxFieldForm.defaultProps = {
  prefixName: "data",
};
